import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/home'
import Heroes from '@/components/heroes'
import Game from '@/components/game'
import Musics from '@/js/musics'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		beforeEnter(to, from, next) {
			Musics.play('main')
			next()
		}
	},
	{
		path: '/heroes',
		name: 'heroes',
		component: Heroes,
		beforeEnter(to, from, next) {
			Musics.play('main')
			next()
		}
	},
	{
		path: '/game',
		name: 'game',
		component: Game
	},
]

const router = new VueRouter({
	routes
})

export default router
